import { connect } from 'react-redux';

import NotFound from '../components/pages/not-found';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({

});

const NotFoundConnector = connect(mapStateToProps, mapDispatchToProps)(NotFound);

export default NotFoundConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/not-found-connector.js
 **/